import { motion } from 'motion/react';
import { ImageWrapper } from './ImageWrapper.jsx';
import { getProductInfo } from '../utils/productHelpers.js';
import Currency from '../utils/Currency.js';

export function CrossSellProduct({ currency, locale, product, crossSell, filteredStoreIds, selected, onClick }) {
  const { commonPrice, normalPrice, mainImage } = getProductInfo(product, filteredStoreIds);

  return (
    <motion.div
        className="w-[48%] h-auto cursor-pointer"
        whileHover={{ y: -10 }}
        whileTap={{ scale: 0.8 }}
        onClick={() => {
          onClick(product);
        }}
      >
        <div className={`w-full h-auto bg-card p-4 ${selected ? 'border-6' : 'border-3'} rounded-[30px] flex gap-4 justify-start`} style={{borderColor: selected ? 'var(--color-primary)' : 'var(--cross-sell-border)', transition: 'border 0.3s ease'}}>
          <div className="w-[150px] aspect-square rounded-[20px] overflow-hidden relative">
            <ImageWrapper
              image={mainImage}
              alt={product.label || product.name}
              display="block"
              width="100%"
              height="100%"
              backgroundColor="transparent"
              margin="0"
              padding="0"
              borderRadius="5px"
              transition={true}
              loadDelay={0.1}
              onLoad={undefined}
            />
          </div>
          <div className="h-auto" style={{ width: 'calc(100% - 150px)' }}>
            {crossSell.tag ? (
              <div className="custom-tag fs-18 secondary-font-bold uppercase px-2 py-1 px-3 rounded-lg inline-block mb-3">
                <div>{crossSell.tag}</div>
              </div>
            ) : null}
            <p className='line-clamp-2 mb-2 leading-tight uppercase tracking-[0.5px] h-[calc(40px*var(--fs-scale))] secondary-font-bold'>
              {product.label || product.name}
            </p>
            {crossSell.description ? (
              <p className='line-clamp-2 mb-2 leading-tight tracking-[0.5px] h-[calc(40px*var(--fs-scale))] primary-font-bold'>
                {crossSell.description}
              </p>
            ) : null}
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-common-price overflow-hidden text-ellipsis">
                {(commonPrice) ? new Currency(currency, locale).format(commonPrice) : "No disponible"}
              </span>
              {(commonPrice && normalPrice && commonPrice < normalPrice) ? <span className="text-sm text-old-price">{normalPrice ? new Currency(currency, locale).format(normalPrice) : "No disponible"}</span> : ""}
            </div>
          </div>
        </div>
      </motion.div>
  );
}